<template>
  <div class="addApplicationSeal">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">个人信息审核</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">个人信息审批流程</div>
        <blank height="7"> </blank>
        <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="Form.state == 2"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">个人信息审核</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">姓名<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.thetitle"
              :disabled="disabled"
              @change="eightyfive('thetitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item label="性别">
            <a-select class="w300" placeholder="请选择" v-model="Form.sex">
              <a-select-option value="男"> 男 </a-select-option>
              <a-select-option value="女"> 女 </a-select-option>
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="年龄">
            <a-input class="w300" placeholder="请添加" v-model="Form.age" />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">民族<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.thetitle"
              :disabled="disabled"
              @change="eightyfive('thetitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">身份证号<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.thetitle"
              :disabled="disabled"
              @change="eightyfive('thetitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">出生时间<span class="required">*</span> </span>
            <a-date-picker
              class="w300"
              v-model="Form.time"
              valueFormat="YYYY-MM-DD"
              :disabled="disabled"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">联系方式<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.thetitle"
              :disabled="disabled"
              @change="eightyfive('thetitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">常住地址<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.thetitle"
              :disabled="disabled"
              @change="eightyfive('thetitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">紧急联系人<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.agent"
              disabled
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >紧急联系人电话<span class="required">*</span> </span
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.agent"
              disabled
            />
          </a-descriptions-item>
          <a-descriptions-item label="全日制教育学历">
            <a-select
              class="w300"
              placeholder="请添加"
              v-model="Form.firstEducation"
            >
              <a-select-option
                v-for="item in bytype.educationList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="卡号">
            <a-input
              class="w300"
              v-model="Form.reason"
              :disabled="disabled"
              @change="eightyfive('reason', 200)"
            />
          </a-descriptions-item>
          <a-descriptions-item label="开户行">
            <a-input
              class="w300"
              v-model="Form.reason"
              :disabled="disabled"
              @change="eightyfive('reason', 200)"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <PremisesPermit></PremisesPermit>
    </div>
    <div class="detial-cont">
      <DisabledCertificate></DisabledCertificate>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ proQueryParams.length === 0 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/sealManagement/details?id="
      skipPageReqFlag="/ApplicationSealDetial"
    >
      <div class="print-title">北京民政工业总公司用印申请审批表单</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="使用部门/单位" :span="3">
              {{ Form.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="用章时间" :span="1.5">
              {{ Form.time }}
            </a-descriptions-item>
            <a-descriptions-item label="份数" :span="1.5">
              {{ Form.number }}
            </a-descriptions-item>
            <a-descriptions-item label="盖章文件标题" :span="1.5">
              {{ Form.thetitle }}
            </a-descriptions-item>
            <a-descriptions-item label="申请人" :span="1.5">
              {{ Form.agent }}
            </a-descriptions-item>
            <a-descriptions-item label="申请事由" :span="3">
              {{ Form.reason }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import { formatDateNoDetails, printFormatDate } from '@/assets/js/auth'
import PremisesPermit from './components/PremisesPermit.vue'
import DisabledCertificate from './components/DisabledCertificate.vue'
// import {
//   updateTheChapterApply,
//   TheChapterApplyDetial,
//   addTheChapterApply
// } from './api/api'
export default {
  components: {
    approvalSubmission,
    approvalChart,
    PremisesPermit,
    DisabledCertificate
  },
  data() {
    return {
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      id: '',
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      // 打印部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      formDTOList: [],
      pIsedit: ''
    }
  },
  computed: {
    ...mapState(['app', 'bytype']),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    //学历
    this.geteducation()
    this.getorganizationUserList()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      this.load()
    } else {
      this.Form.agent = this.$store.state.app.userInfo.fullName
      let date = new Date()
      this.$set(this.Form, 'time', formatDateNoDetails(date))
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '用印申请-' + this.Form.agent + printFormatDate(new Date())
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.load()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    load() {
      TheChapterApplyDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    ...mapActions(['getorganizationUserList', 'geteducation']),
    goback() {
      this.$router.push('/ApplicationSeal')
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.time) {
        this.$message.error('请添加用章时间')
        return false
      }
      if (!this.Form.number) {
        this.$message.error('请添加份数')
        return false
      }
      if (!this.Form.thetitle) {
        this.$message.error('请添加盖章文件标题')
        return false
      }
      if (!this.Form.agent) {
        this.$message.error('请添加申请人')
        return false
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },

    submitFn() {
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.time) {
        this.$message.error('请添加用章时间')
        return false
      }
      if (!this.Form.number) {
        this.$message.error('请添加份数')
        return false
      }
      if (!this.Form.thetitle) {
        this.$message.error('请添加盖章文件标题')
        return false
      }
      if (!this.Form.agent) {
        this.$message.error('请添加申请人')
        return false
      }
      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('保存修改')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('提交')
          }
        })
      }
    },
    saveFormFn(type) {
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/ApplicationSealDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        updateTheChapterApply(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.load()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.app.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organizationName = organizationName
        addTheChapterApply(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.load()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addApplicationSeal {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/InfoApproval/detail.vue